(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvDateTimeInput', function () {
            
            return  {
                templateUrl: 'app/fieldinput/date-time-input.tmpl.html',
                require: "ngModel",
                scope: {
                    value: '=ngModel',
                    mandatory: '='
                },
                controller: ['$scope', function ($scope) {
                    var drvCtrl = this;
                    drvCtrl.updateDateTimeValue = updateDateTimeValue;
                    drvCtrl.showSuffix = showSuffix;
                    Object.defineProperty(drvCtrl, 'invalid', {
                        get: function () {
                            return (!_.isNil(drvCtrl.field) && drvCtrl.field.Mandatory && (_.isNil(drvCtrl.date) || drvCtrl.date === '' || _.isNil(drvCtrl.time) || drvCtrl.time === ''));
                        }
                    });

                    activate();

                    function activate() {
                        drvCtrl.dateTime = new Date(drvCtrl.value);
                    }

                    $scope.$watch(function () {
                        return drvCtrl.value;
                    }, function () {
                        if (!angular.isUndefined(drvCtrl.value) && drvCtrl.value !== null && drvCtrl.value !== '') {
                            drvCtrl.date = new Date(drvCtrl.value);
                            drvCtrl.time = new Date(drvCtrl.value);
                            updateDateTimeValue();
                        }
                    });

                    function updateDateTimeValue() {
                        if ((angular.isUndefined(drvCtrl.date) || drvCtrl.date === null) && (angular.isUndefined(drvCtrl.time) || drvCtrl.time === null)) {
                            drvCtrl.value = '';
                        }
                        else {
                            var currentDate = new Date();
                            var year = currentDate.getFullYear();
                            var month = currentDate.getMonth();
                            var day = currentDate.getDate();
                            var hour = currentDate.getHours();
                            var minute = currentDate.getMinutes();

                            if (!angular.isUndefined(drvCtrl.date) && drvCtrl.date !== null) {
                                year = drvCtrl.date.getFullYear();
                                month = drvCtrl.date.getMonth();
                                day = drvCtrl.date.getDate();
                            }

                            if (!angular.isUndefined(drvCtrl.time) && drvCtrl.time !== null) {
                                hour = drvCtrl.time.getHours();
                                minute = drvCtrl.time.getMinutes();
                            }

                            var newDate = new Date(year, month, day, hour, minute);

                            if (angular.isUndefined(drvCtrl.dateTime) || drvCtrl.dateTime === null || year !== drvCtrl.dateTime.getFullYear() ||
                                month !== drvCtrl.dateTime.getMonth() || day !== drvCtrl.dateTime.getDate() || hour !== drvCtrl.dateTime.getHours() || minute !== drvCtrl.dateTime.getMinutes())
                            {
                                var updateDateValue = true;
                                try {
                                    // Only update the value if it's changed.
                                    // This check is necessary because the date can sometimes be in a diffrent format, but represent the same date.
                                    // If the format changes (even though the dates the same), the "unsaved changes" service will incorrectly mark the record as changed.
                                    var d1 = new Date(drvCtrl.value);
                                    if (d1.toISOString() === newDate.toISOString()) {
                                        updateDateValue = false;
                                    }
                                } catch (dateException) {}

                                drvCtrl.dateTime = angular.copy(newDate);

                                if (updateDateValue) {
                                    drvCtrl.value = angular.copy(newDate);
                                }
                            }
                        }
                    }

                    function showSuffix() {
                        return !_.isNil(drvCtrl.field) && !_.isNil(drvCtrl.field.Suffix) && drvCtrl.field.Suffix !== '';
                    }
                }],
                controllerAs: 'drvCtrl',
                bindToController: {
                    value: '=ngModel',
                    field: '='
                }
            };
        });
})();